import { render, staticRenderFns } from "./ZonaDescargas.vue?vue&type=template&id=7eb5f154&scoped=true"
import script from "./ZonaDescargas.vue?vue&type=script&setup=true&lang=js"
export * from "./ZonaDescargas.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ZonaDescargas.vue?vue&type=style&index=0&id=7eb5f154&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7eb5f154",
  null
  
)

export default component.exports